export const commonConstants = {
  GET_AYDINLATMA_REQUEST: "GET_AYDINLATMA_REQUEST",
  GET_AYDINLATMA_SUCCESS: "GET_AYDINLATMA_SUCCESS",
  SET_AYDINLATMA_REQUEST: "SET_AYDINLATMA_REQUEST",
  SET_AYDINLATMA_SUCCESS: "SET_AYDINLATMA_SUCCESS",
  HIDE_AYDINLATMA_MODAL: "HIDE_AYDINLATMA_MODAL",
  AYDINLATMA_ERROR: "AYDINLATMA_ERROR"
};
